import {
	requests
}from "../../../../api/agent"

export default {
	create        : (params) => requests.post('/ReMeasurementUnit/create', params),
	update        : (params) => requests.post('/ReMeasurementUnit/update', params),
	delete        : (params) => requests.getWithParams('/ReMeasurementUnit/delete', params),
	restore       : (params) => requests.getWithParams('/ReMeasurementUnit/restore', params),
	getPaged      : (params) => requests.getWithParams('/ReMeasurementUnit/getPaged', params),
	getPagedAudit : (params) => requests.getWithParams('/ReMeasurementUnit/getPagedAudit', params),
	getPagedAll   : (params) => requests.getWithParams('/ReMeasurementUnit/getPagedAll', params),
	getList       : (params) => requests.getWithParams('/ReMeasurementUnit/getList', params)
}